<script setup lang="ts">
import { AccordionContent, AccordionHeader, AccordionItem, AccordionRoot, AccordionTrigger } from "reka-ui";

const { status, filters, params } = useShop();
const opened = ref("");
</script>

<template>
  <div v-if="status === 'success'" class="space-y-2">
    <div class="flex items-center justify-between gap-4">
      <h2 class="text-xl font-medium">
        Filtres
      </h2>
      <slot name="close" />
    </div>
    <ShopFiltersChanged />
    <ShopFiltersSearch />
    <AccordionRoot v-model="opened" type="single" :collapsible="true" class="divide-y-2 divide-light border-y-2 border-light">
      <AccordionItem v-for="filter in filters" :key="filter.name" :value="filter.name">
        <AccordionHeader class="flex text-lg font-semibold text-primary">
          <AccordionTrigger class="group flex flex-1 items-center justify-between gap-4 py-2 text-left">
            {{ filter.label }}
            <span class="i-lucide-chevron-down size-6 shrink-0 transition group-data-[state=open]:rotate-180" />
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent class="animation-accordion px-1 pb-2">
          <Component :is="filter.component" v-model="params[filter.name]" v-bind="filter.attrs" />
        </AccordionContent>
      </AccordionItem>
    </AccordionRoot>
  </div>
</template>
